document.addEventListener("DOMContentLoaded", () => {
  const urlParams = new URLSearchParams(window.location.search);
  const orderParam = urlParams.get("order");
  const emailParam = urlParams.get("email");

  if (orderParam && emailParam) {
    document.getElementById("order").value = orderParam;
    document.getElementById("email").value = emailParam;
    document.getElementById("image-nps").style.display = "none";
    document.getElementById("form-order").style.display = "block";
  } else if (emailParam) {
    document.getElementById("image-nps").style.display = "none";
    document.getElementById("form-order").style.display = "block";
  }
});

function showFadeInMessage() {
  const fadeInMessage = document.getElementById("fade-in-message");
  fadeInMessage.style.display = "block";
  fadeInMessage.innerHTML = `
    <div id="klaviyo-grid" style="max-width:550px;" class="klaviyo-form-WAbCkf"></div> 
  `;
  setTimeout(() => {
    fadeInMessage.style.opacity = 1;
  }, 100);
}

function onSubmit(e) {
  e.preventDefault();
  document.getElementById("error-message").innerText = "";
  const form = document.getElementById("form-order");
  const spinner = document.getElementById("spinner");
  const imageNps = document.getElementById("image-nps");
  const order = document.getElementById("order").value;
  const submit = document.getElementById("submit");
  const urlParams = new URLSearchParams(window.location.search);
  const emailParam = urlParams.get("email").replace("%40", "@");
  const requestOptions = {
    method: "GET",
    redirect: "follow",
  };
  submit.innerText = "Validando...";
  spinner.style.display = "block";
  fetch(
    `https://klaviyo-unsuscribe.onrender.com/bebesit/validate/${order.toUpperCase()}/${emailParam.toLowerCase()}`,
    requestOptions
  )
    .then((response) => response.json())
    .then((result) => {
      if (result.isSuccess) {
        form.style.display = "none";
        imageNps.style.display = "none";
        showFadeInMessage();
      } else {
        document.getElementById("error-message").innerText =
          "El número de orden es incorrecto o ya se ha redimido antes.";
      }
    })
    .catch((error) => {
      console.log("error", error);
      document.getElementById("error-message").innerText =
        "Ocurrió un error, por favor intente nuevamente más tarde.";
    })
    .finally(() => {
      submit.disabled = false;
      spinner.style.display = "none";
    });
}
